var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4361 13.91H15.4753C13.387 13.91 12.6909 15.8527 12.6909 17.3904C12.7 17.9673 12.8285 18.5361 13.0682 19.061C13.1343 19.2118 13.297 19.2957 13.4581 19.2621C13.6193 19.2284 13.7349 19.0864 13.735 18.9218V18.4387C13.735 17.7426 14.0831 17.3946 15.4753 17.3946H22.4361V19.1348C22.4361 19.3262 22.5412 19.3673 22.67 19.2253L25.6827 15.9119C25.8114 15.7643 25.8114 15.5444 25.6827 15.3968L22.67 12.0834C22.5412 11.9442 22.4361 11.9825 22.4361 12.1739V13.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5638 25.7434H24.5246C26.6129 25.7434 27.309 23.8006 27.309 22.263C27.2995 21.6872 27.1711 21.1196 26.9317 20.5959C26.8657 20.445 26.7029 20.3611 26.5418 20.3948C26.3806 20.4284 26.265 20.5704 26.2649 20.7351V21.2175C26.2649 21.9135 25.9168 22.2616 24.5246 22.2616H17.5638V20.5214C17.5638 20.3299 17.4587 20.2896 17.3299 20.4309L14.3172 23.7443C14.1885 23.8918 14.1885 24.1118 14.3172 24.2594L17.3299 27.5727C17.4587 27.712 17.5638 27.6737 17.5638 27.4822V25.7434Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTransfer);
export default __webpack_public_path__ + "static/media/data-transfer.92f89d89.svg";
export { ForwardRef as ReactComponent };